
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { getCompanySet, modifyCompanySet } from '@/api/system';
import { fstat } from 'fs';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import { regular } from '@/const/regular';

@Component({
  name: 'KpiSetting'
})

export default class extends Vue {

  private windowHg = window.innerHeight - 95;
  private tabActive = 'first'


  private kpiForm = {

    is_bonus_fine_order:false,
    bonus_order_hours:'',
    bonus_order_amount:'',
    fine_order_hours:'',
    fine_order_amount:'',

    // is_bonus_fine_parts:'',
    // bonus_parts_hours:'',
    // bonus_parts_ratio:'',
    // fine_parts_hours:'',
    // fine_parts_ratio:'',

    // is_bonus_fine_price:'',
    // bonus_price_hours:'',
    // bonus_price_ratio:'',
    // fine_price_hours:'',
    // fine_price_ratio:'',

  }

  created() {
    // this.PersonStock = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.PersonStock);
    this.getCompanySet();

  }


  private getCompanySet() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.vip_level = (UserModule.company as any).vip_level;
    getCompanySet(params).then(res => {
      if (res.data && res.data.companySet) {
        this.kpiForm.is_bonus_fine_order = parseInt(res.data.companySet.is_bonus_fine_order)==1 ? true : false;
        this.kpiForm.bonus_order_hours = res.data.companySet.bonus_order_hours;
        this.kpiForm.bonus_order_amount = res.data.companySet.bonus_order_amount;
        this.kpiForm.fine_order_hours = res.data.companySet.fine_order_hours;
        this.kpiForm.fine_order_amount = res.data.companySet.fine_order_amount;
      }
    }).catch(err => {
      let msg = err.msg;
    });
  }
  
  private saveParsCompanySet(val:number) {
    let pamars:any = {};
    pamars.user_id = UserModule.getUserId;
    pamars.company_id = UserModule.getCompanyId;
    // switch (val) {
    //   case 1:
    //     pamars.is_sync_spare_parts = this.checkedActive ? '1' : '0';
    //     break;
    //   case 2:
    //     pamars.is_stock_out_set = this.stockSettingChecked ? '1' : '0';
    //     break;
    //   case 3:
    //     pamars.is_stock_warning = this.formWarning.warning ? '1' : '0';
    //     pamars.stock_warning_number = this.formWarning.number;
    //     break;
    //   case 4:
    //     pamars.is_stock_auto_charge_off = this.stockAutoChargeOff ? '1' : '0';
    //     break;
    // }
    console.log(this.kpiForm);
    if( !this.moneyRegExpTest(this.kpiForm.bonus_order_amount) ||  !this.moneyRegExpTest(this.kpiForm.fine_order_amount) ){
      this.showErrorMsg("请输入正确的金额");
      return ;
    }
    pamars.is_bonus_fine_order =  this.kpiForm.is_bonus_fine_order ? '1' : '0' ;
    pamars.bonus_order_hours =  this.kpiForm.bonus_order_hours;
    pamars.bonus_order_amount =  this.kpiForm.bonus_order_amount;
    pamars.fine_order_hours =  this.kpiForm.fine_order_hours;
    pamars.fine_order_amount =  this.kpiForm.fine_order_amount;
    this.saveCopanySet(pamars);

  }

  private saveCopanySet(params:any) {
    modifyCompanySet(params).then(res => {
      this.showSuccessMsg((res as any).msg);
      //更新完成刷新
      this.getCompanySet();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private tabBefore(activeName: any) {
    if (activeName === 'empty-1' || activeName === 'empty-2') {
      return false;
    }
  }

  private tabChange() {
    // if (this.activeName === 'first') {
    // }      
  }

  //：https://blog.csdn.net/a99101/article/details/128912573
  private moneyRegExpTest(money:any) {
    const regExp:RegExp = /^[0-9]+.?[0-9]{0,2}?$/;
    return regExp.test(money);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

}
